<p>SharedModels works!</p>
